import { el } from 'redom';

import { stringToSVG } from 'utilities';

import searchIconString from 'assets/images/search-icon.svg?raw';

const searchIcon = stringToSVG(searchIconString);

class EventRegistrartionsFilter {

  constructor(onChange) {

    this.onChange = onChange;

    this.searchIconViewEl = el('div.search-icon', searchIcon.cloneNode(true));
    this.searchInputControlViewEl = el('input.search-input-control', { type: 'text', placeholder: 'Search Guests' });

    this.registerEventHandlers();

    this.el = el('div.event-search-box-control', [this.searchIconViewEl, this.searchInputControlViewEl]);

  }

  registerEventHandlers() {

    this.searchInputControlViewEl.addEventListener('keyup', function keyupEventHandler(event) {
      this.onChange(event.target.value);
    }.bind(this));

  }

}

export default EventRegistrartionsFilter;